import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearAdPreview } from 'redux/modules/adBuilder';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import { LoaderBar, Spinner } from 'components';
import * as styles from './IframePreview.scss';
import _ from 'lodash';

var cheerio = require('cheerio');

var IframePreview = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {
  clearAdPreview: clearAdPreview
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(IframePreview, _Component);

  var _super = _createSuper(IframePreview);

  function IframePreview(props) {
    var _this;

    _classCallCheck(this, IframePreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function (nextProps, nextState) {
      return !_.isEqual(nextProps, _this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdPreview", function () {
      var previewType = _this.props.selectedPreviewTab;
      var html;

      switch (previewType) {
        case 'DESKTOP_FEED_STANDARD':
          if (_this.props.DESKTOP_FEED_STANDARD) {
            html = _this.props.DESKTOP_FEED_STANDARD;
          }

          break;

        case 'INSTAGRAM_STANDARD':
          if (_this.props.INSTAGRAM_STANDARD) {
            html = _this.props.INSTAGRAM_STANDARD;
          }

          break;

        case 'MESSENGER_MOBILE_INBOX_MEDIA':
          if (_this.props.MESSENGER_MOBILE_INBOX_MEDIA) {
            html = _this.props.MESSENGER_MOBILE_INBOX_MEDIA;
          }

          break;

        case 'RIGHT_COLUMN_STANDARD':
          if (_this.props.RIGHT_COLUMN_STANDARD) {
            html = _this.props.RIGHT_COLUMN_STANDARD;
          }

          break;

        case 'MOBILE_FEED_STANDARD':
          if (_this.props.MOBILE_FEED_STANDARD) {
            html = _this.props.MOBILE_FEED_STANDARD;
          }

          break;

        default:
          html = '';
          break;
      }

      if (html) {
        var $ = cheerio.load(html);
        return /*#__PURE__*/React.createElement("iframe", {
          src: $('iframe').attr('src'),
          width: _this.props.iframeWidth ? _this.props.iframeWidth : $('iframe').attr('width'),
          height: $('iframe').attr('height'),
          scrolling: "auto",
          style: {
            border: 'none',
            height: '100%',
            minHeight: 550
          },
          onLoad: _this.props.onLoad
        });
      }

      return /*#__PURE__*/React.createElement("span", null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdBlockMessage", function () {
      return /*#__PURE__*/React.createElement(AdBlockDetect, null, /*#__PURE__*/React.createElement(Paper, {
        zDepth: 2,
        style: {
          borderRadius: 4,
          marginTop: 24
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRadius: '4px 0 0 4px',
          flex: '0 0 75px',
          flexDirection: 'column',
          backgroundColor: _this.props.theme.colors.warningColor,
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle",
        style: {
          color: 'white',
          fontSize: 20,
          width: '100%',
          textAlign: 'center'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 12
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          fontSize: 16,
          color: _this.props.theme.colors.gray1
        }
      }, "Your ad preview would be here."), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: _this.props.theme.colors.gray1,
          lineHeight: '15px'
        }
      }, "Turn off your ad blocker or add this page's URL as an exception so you can see the preview for your ad. After you turn off the ad blocker, you'll need to refresh your screen.")))));
    });

    return _this;
  }

  _createClass(IframePreview, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearAdPreview(this.props.organization.id);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", _defineProperty({
        style: {
          height: '100%'
        }
      }, "style", this.props.style), this.renderAdPreview(), this.renderAdBlockMessage());
    }
  }]);

  return IframePreview;
}(Component), _defineProperty(_class2, "propTypes", {
  selectedPreviewTab: PropTypes.string,
  onLoad: PropTypes.func
}), _defineProperty(_class2, "defaultProps", {
  iframeWidth: null,
  style: {}
}), _temp)) || _class);
export default IframePreview;